var map = {
	"./block-category-line/_index.js": 4131,
	"./block-faq/_index.js": 8241,
	"./block-feedback/_index.js": 7433,
	"./block-hero/_index.js": 8656,
	"./block-new-products/_index.js": 6874,
	"./block-promo/_index.js": 373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9820;